// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"171":"867cecdb","787":"e4e5836c"}[chunkId] + ".chunk.js";
};